module.exports = __webpack_public_path__ + "static/media/electronics-300.44f03cd8.png";